import _ from 'lodash';
import { fromJS } from 'immutable';
import Reflux from 'reflux';
import Actions from './actions';
import helpers from './helpers';

// Load Data
const DATES = require('../../data/dates');
const DATA = {
  'presidential-candidates': require('../../data/candidates'),
  'gun-control': require('../../data/gun_control'),
  'immigration-policy': require('../../data/immigration_policy'),
  'tax-policy': require('../../data/tax_policy')
};

const mapColors = ['#244999', '#d22532', '#a8adb4'];

const Store = Reflux.createStore({

  listenables: Actions,

  init() {
    this.months = helpers.getMonths();
    this.categories = this.getCategories();
  },

  /* Action Handlers */
  onFetchData({ dataset, wave, month }) {
    helpers.redirectToLastWave(dataset, wave, month);
    this.dataset = dataset;

    const dataByMonth = this.groupDataByMonth();
    let mapResults = fromJS(this.getMapData(dataByMonth, month, wave));
    let currentResults = fromJS(this.getCurrentResults(dataByMonth, month, wave));

    this.trigger({ currentResults, mapResults });
  },

  onGetLineChartData() {
    const data = this.groupDataByMonth();
    const categories = fromJS(this.getCategories());
    const pro = [], anti = [], neutral = [];

    _.each(data, (month) => {
      const row = _.filter(month, { state: 'National' });

      pro.push(helpers.average(row, 'pro'));
      anti.push(helpers.average(row, 'anti'));
      neutral.push(helpers.average(row, 'neutral'));
    });

    let lineChartData = [
      { name: 'pro', data: pro, color: '#1695a3' },
      { name: 'anti', data: anti, color: '#ff4454' },
      { name: 'neutral', data: neutral, color: '#a8adb4' }
    ];

    if (this.dataset === 'presidential-candidates') {
      lineChartData = helpers.transformValuesRecursively(lineChartData);
      lineChartData = _.map(lineChartData, (row, k) => {
        row.color = mapColors[k];
        return row;
      })
    }

    this.trigger({
      categories, lineChartData: fromJS(lineChartData)
    });
  },

  onGetMonths() {
    this.trigger({ months: fromJS(helpers.getMonths()) });
  },

  /* End Action Handlers */

  getCurrentResults(data, month, wave) {
    let results;
    if (!wave) {
      results = this.getAverageMonthData(data, month);
    } else {
      results = _.find(DATA[this.dataset], { wave });
    }
    if (this.dataset === 'presidential-candidates') {
      results = helpers.transformKeys(results);
    }

    return _.omit(results, 'wave', 'state', 'stateName', 'maxIndex');
  },

  getMapData(data, month, wave) {
    const dataByState = this.groupDataByState();

    return _.chain(dataByState)
      .omit('National')
      .map((rows, state) => {
        let stateData;

        if (!wave) {
          stateData = this.getStateAvgByMonth(rows, state);
        } else {
          stateData = this.getStateDataByWave(rows, wave);
        }

        if (this.dataset === 'presidential-candidates') {
          stateData = helpers.transformKeys(stateData);

          if (stateData.other === 0 || stateData.other.length === 0) {
            stateData = _.omit(stateData, 'other');
          }
        }

        return stateData;
      }).value();
  },

  getStateAvgByMonth(row, state) {

    const pro = helpers.average(row, 'pro'),
          anti = helpers.average(row, 'anti'),
          neutral = helpers.average(row, 'neutral'),
          maxIndex = helpers.returnIndexOfMax([ pro, anti, neutral ]);

    return { state, pro, anti, neutral, maxIndex };
  },

  getStateDataByWave(rows, wave) {
    let row = _.find(rows, { wave });
    row.maxIndex = helpers.returnIndexOfMax([ row.pro, row.anti, row.neutral ]);
    return row;
  },

  getCategories() {
    return this.categories || _.map(helpers.getMonths(), (arr) => arr[0]);
  },

  groupDataByMonth() {
    return _.groupBy(DATA[this.dataset], (val) => {
      const row = _.find(DATES, { wave: val.wave }) || {};
      return helpers.filterByDate(row);
    });
  },

  groupDataByState() {
    return _.groupBy(DATA[this.dataset], 'state');
  },

  getAverageMonthData(data, month) {

    return {
      wave: '',
      pro: helpers.average(data[month], 'pro', { state: 'National'} ),
      anti: helpers.average(data[month], 'anti', { state: 'National' }),
      neutral: helpers.average(data[month], 'neutral', { state: 'National' })
    };
  },

});

export default Store;



/** WEBPACK FOOTER **
 ** ./src/components/data_visualisation/store.js
 **/